var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"rating"}},[_c('div',{staticClass:"rating-text"},[_vm._v("评级")]),_vm._v(" "),_c('div',{staticClass:"star-list"},_vm._l((_vm.MAX_STAR_NUMBER),function(item,index){return _c('div',{key:index,class:[_vm.starNum > index ? 'star-active' : 'star']})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c322cd7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rating/rating.vue
// module id = null
// module chunks = 